import { Flex } from "@chakra-ui/react";
import { Ganhos } from "./Ganhos";

export function ContainerGanhos() {
  return (
    <Flex flexDirection={"column"}>
      <Flex gap=".1rem">
        <Ganhos label="Quero ganhar %" bg="#30B390" width="18.2rem" />
        <Ganhos label="Quero ganhar" bg="#30B390" width="6rem" />
        <Ganhos label="Desconto %" bg="#30B390" width="30.4rem" />
        <Ganhos label="Desconto" bg="#30B390" width="18.2rem" />
      </Flex>
      <Flex gap=".1rem">
        <Ganhos label="360%" bg="white" width="18.2rem" color="#333" border />
        <Ganhos label="R$ 70,00" bg="white" width="6rem" color="#333" border />
        <Ganhos label="10%" bg="white" width="30.4rem" color="#333" border />
        <Ganhos label="20%" bg="white" width="18.2rem" color="#333" border />
      </Flex>
    </Flex>
  );
}
